import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBCheckBox, RedoButton } from '_components';
import styles from './Common.module.css';


class AlTherActRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLTHERACT', 'XLTA', this.props.theract.XLTANO);
    }

    handlePerformed(val) {
        if (!this.props.onAssessment && val === true) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLTHERACT', true);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.theract.XLTAPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBDropDown
                            field='XLTATANO'
                            noteId={this.props.noteId}
                            entity='MLTHERACT'
                            entityKeyColumn='XLTANO'
                            entityKeyValue={this.props.theract.XLTANO}
                            className={this.props.theract.XLTAPERFORMED && !this.props.theract.XLTATANO ? styles.col1_performed : styles.col1}
                            customOptions={this.props.activities}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLTHERACT'
                            entityKeyColumn='XLTANO'
                            entityKeyValue={this.props.theract.XLTANO}
                            field='XLTAACTIVITY'
                            className={this.props.theract.XLTAPERFORMED && !this.props.theract.XLTAACTIVITY ? styles.col2_performed : styles.col2}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLTHERACT'
                            entityKeyColumn='XLTANO'
                            entityKeyValue={this.props.theract.XLTANO}
                            field='XLTASETSREPS'
                            className={this.props.theract.XLTAPERFORMED && !this.props.theract.XLTASETSREPS ? styles.col3_performed : styles.col3}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLTHERACT'
                            entityKeyColumn='XLTANO'
                            entityKeyValue={this.props.theract.XLTANO}
                            field='XLTAPERFORMED'
                            className={styles.col4}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <span className={styles.col5} />
                    </div>
                    {this.props.prevVisit &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col6}>
                                <RedoButton size='extra-small' title='Performed during previous visit' />
                            </span>
                        </div>
                    }
                </div>
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let theract = state.entities.notes.MLTHERACT[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLTHERACTPREV)
        .find(key => (state.entities.notes.MLTHERACTPREV[key].NoteId === noteId &&
            state.entities.notes.MLTHERACTPREV[key].XLTATANO === theract.XLTATANO &&
            state.entities.notes.MLTHERACTPREV[key].XLTAACTIVITY === theract.XLTAACTIVITY
        )) !== undefined ? true : false;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let onAssessment = state.entities.notes.PTPLAN[plno] && state.entities.notes.PTPLAN[plno].PLTHERACT ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;

    let activities = state.entities.masterData.MLMASTERTHERACT ?
        Object.keys(state.entities.masterData.MLMASTERTHERACT)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTERTHERACT[key].TAPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTERTHERACT[key].TAMC) ||
                    (isWc && state.entities.masterData.MLMASTERTHERACT[key].TAWC) ||
                    (isAuto && state.entities.masterData.MLMASTERTHERACT[key].TAAUTO) ||
                    (isOther && state.entities.masterData.MLMASTERTHERACT[key].TAOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTERTHERACT[a].TANAME.localeCompare(state.entities.masterData.MLMASTERTHERACT[b].TANAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERTHERACT[key].TANO,
                    value: state.entities.masterData.MLMASTERTHERACT[key].TANAME
                }
            )) : [];
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        theract: theract,
        activities: activities,
        prevVisit: prevVisit,
        onAssessment,
        plno,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlTherActRow = connect(mapStateToProps, mapDispatchToProps)(AlTherActRow);
export { connectedAlTherActRow as AlTherActRow };

